import { render, staticRenderFns } from "./DetalhamentoStatusEquipe.vue?vue&type=template&id=79089f9e&"
import script from "./DetalhamentoStatusEquipe.vue?vue&type=script&lang=js&"
export * from "./DetalhamentoStatusEquipe.vue?vue&type=script&lang=js&"
import style0 from "./DetalhamentoStatusEquipe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports